(function ($) {
    $(function () {
        $('.more-service .parent > li > a').on('click', function () {
            $('.more-service .child').slideUp();
            $(this).next().slideToggle();
        });


        var topBtn = $('#pagetop');
        topBtn.hide();
        $(window).scroll(function () {
            if ($(this).scrollTop() > 200) {
                topBtn.fadeIn();
            } else {
                topBtn.fadeOut();
            }
        });


        $('.btn-denwa-sp-btn,.btn-denwa-sp-btn-close').on('click', function () {
            $('#denwa-cont-nav').slideToggle();
            $('.denwa-cont-nav-wrap').toggleClass('is-open');
            $('.btn-denwa-sp-btn').toggleAttrVal('aria-pressed', "true", "false");
        });


        $('.more-knowledge-slider ul').slick({
            autoplay: true,
            dots: false,
            speed: 500,
            infinite: true,
            prevArrow: '<div class="prev"></div>',//矢印部分PreviewのHTMLを変更
            nextArrow: '<div class="next"></div>',//矢印部分NextのHTMLを変更
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
            ]
        });


        $('.contact-btns .list-btn-item-tel a').append('<p>※受付時間&nbsp;平日9:00〜17:00(年末年始は除きます)</p>');


        $('.faq-item h2').on('click',function () {
            $(this).next().slideToggle();
            $(this).toggleClass('is-open');
        });


        $(window).on('load scroll', function() {
            FixedAnime();
        });

        function FixedAnime() {
            var headerH = $('#header').outerHeight(true);
            var navH = $('.denwa-cont-nav-wrap').outerHeight(true);
            var ofsetH = headerH + navH;
            var scroll = $(window).scrollTop();
            if (scroll >= ofsetH){
                $('.denwa-cont-nav-wrap').addClass('is-fixed');
            }else{
                $('.denwa-cont-nav-wrap').removeClass('is-fixed');
            }
        }


    });


    $.fn.toggleAttrVal = function (attr, val1, val2) {
        var test = $(this).attr(attr);
        if (test === val1) {
            $(this).attr(attr, val2);
            return this;
        }
        if (test === val2) {
            $(this).attr(attr, val1);
            return this;
        }
        // default to val1 if neither
        $(this).attr(attr, val1);
        return this;
    };
})(jQuery);






